import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router'
import { ClinicModulesPreferences, ClinicService } from '@mmx/shared'
import { RoutingService } from 'app/core/services'
import { every } from 'lodash'
import { Observable, of } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ClinicModulesGuard implements CanActivate {
  constructor(
    private clinicService: ClinicService,
    private router: Router,
    private routingSvc: RoutingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.clinicService.clinic$.pipe(
      map(clinic => {
        if (clinic == null) {
          return false
        }

        const hasRequiredModules = every(
          route.data?.modules ?? [],
          (clinicModule) => clinic.modules?.[clinicModule],
        )

        const hasRequiredModulePreferences = every(
          (route.data?.modulesPreferences ?? []) as Array<keyof ClinicModulesPreferences>,
          (modulePreference) => clinic.modulesPreferences?.[modulePreference],
        )

        return hasRequiredModules && hasRequiredModulePreferences
      }),
      tap(value => {
        if (!value) {
          this.router.navigateByUrl(this.routingSvc.getFirstAuthenticatedRoute())
        }
      }),
      catchError(() => of(false)),
    )
  }
}
